import { render, staticRenderFns } from "./freePractice.vue?vue&type=template&id=3e694e44&scoped=true"
import script from "./freePractice.vue?vue&type=script&lang=js"
export * from "./freePractice.vue?vue&type=script&lang=js"
import style0 from "./freePractice.vue?vue&type=style&index=0&id=3e694e44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e694e44",
  null
  
)

export default component.exports